export default __webpack_public_path__ + "static/media/ribborn.561f24bc.svg";